 <div class="flex flex-row items-center" [ngClass]="className">
  <nx-default-button
    class="ml-2"
    (click)="dayBack()"
    [style]="'dark'"
    [tooltip]="'sharedModule.dateSelectorComponent.buttons.dayBack.tooltip' | translate"
    [icon]="'icon-arrow-left'">
  </nx-default-button>
  <p-calendar
    #calendar
    [(ngModel)]="selectedDate"
    [showIcon]="false"
    (onSelect)="dateChange($event)"
    [style]="{ width:'0px' }">
  </p-calendar>

  <nx-default-button
    class="ml-2"
    (click)="toggleCalendar($event)"
    [style]="'dark'"
    [tooltip]="'sharedModule.dateSelectorComponent.buttons.calendar.tooltip' | translate"
    [label]="selectedDate ? (selectedDate | date: 'dd.MM.yyyy') : ('sharedModule.dateSelectorComponent.buttons.calendar.placeholder' | translate)">
  </nx-default-button>
  <nx-default-button
    class="ml-2"
    (click)="!isToday() ? loadToday() : null"
    [style]="'dark'"
    [tooltip]="'sharedModule.dateSelectorComponent.buttons.today.tooltip' | translate"
    [disabled]="isToday()"
    [label]="'sharedModule.dateSelectorComponent.buttons.today.label' | translate">
  </nx-default-button>
  <nx-default-button
    class="ml-2"
    [style]="'dark'"
    (click)="dayForward()"
    [tooltip]="'sharedModule.dateSelectorComponent.buttons.dayForward.tooltip' | translate"
    [icon]="'icon-arrow-right'">
  </nx-default-button>
</div>
